import { render, staticRenderFns } from "./mitra-period-edit-bonus-date.vue?vue&type=template&id=5c10c57e&"
import script from "./mitra-period-edit-bonus-date.vue?vue&type=script&lang=js&"
export * from "./mitra-period-edit-bonus-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports